require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-secret-cinema-sessions.json") })
        }
      }, "path---interview-secret-cinema-sessions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-secret-cinema-sessions!./.cache/json/interview-secret-cinema-sessions.json
// module id = 710
// module chunks = 231608221292675